import { useMutation, useQuery, useQueryClient } from 'react-query'
import { systemIssuesService } from '../../../services/systemIssuesService'
import { issueKey, myIssuesKey } from './useSystemIssues'

export const mentionCandidatesKey = ['system-issues', 'mention-candidates'] as const
export const issueMentionCandidatesKey = (issueId: number) =>
  ['system-issues', 'mention-candidates', issueId] as const

/** Candidatos pro formulário de "novo problema" — colegas da empresa
 * escolhida no formulário (ausente = empresa principal). */
export function useMentionCandidates(companyId?: number | null, enabled = true) {
  return useQuery(
    // 'company' separa do `issueMentionCandidatesKey(id)` — sem ele a chave
    // da empresa 78 era a mesma dos candidatos da issue #78.
    [...mentionCandidatesKey, 'company', companyId ?? 'principal'],
    () => systemIssuesService.listMentionCandidates(companyId),
    { enabled, staleTime: 60 * 1000 },
  )
}

/** Candidatos pra marcar numa issue já criada — colegas do CC do REPORTER
 * (backend resolve isso a partir de `issue.company_id`). */
export function useMentionCandidatesForIssue(issueId: number | null) {
  return useQuery(
    issueId ? issueMentionCandidatesKey(issueId) : ['system-issues', 'mention-candidates', 'idle'],
    () => systemIssuesService.listMentionCandidatesForIssue(issueId as number),
    { enabled: !!issueId, staleTime: 60 * 1000 },
  )
}

export function useTagMentions(issueId: number) {
  const qc = useQueryClient()
  return useMutation(
    (accountIds: number[]) =>
      systemIssuesService.tagMentions(issueId, accountIds),
    {
      onSuccess: () => {
        qc.invalidateQueries(issueKey(issueId))
        qc.invalidateQueries(myIssuesKey)
      },
    },
  )
}

export function useUntagMention(issueId: number) {
  const qc = useQueryClient()
  return useMutation(
    (accountId: number) =>
      systemIssuesService.untagMention(issueId, accountId),
    {
      onSuccess: () => {
        qc.invalidateQueries(issueKey(issueId))
        qc.invalidateQueries(myIssuesKey)
      },
    },
  )
}
